import { useState } from 'react';
import { TaxInfoModal } from './TaxInfoModal';
import type { TaxModalConfig, TaxModalPriceRows } from '../utils/taxInfoModal';
import './TaxInfoModal.css';

export type PriceTaxLabelButtonProps = {
  label: string;
  className?: string;
  config: TaxModalConfig;
  prices?: TaxModalPriceRows;
};

/** Tax hint as a button that opens the Preisinformationen modal. */
export function PriceTaxLabelButton({
  label,
  className = '',
  config,
  prices,
}: PriceTaxLabelButtonProps) {
  const [open, setOpen] = useState(false);
  const text = String(label || '').trim();
  if (!text) return null;
  const btnClass = className ? `price-tax-label ${className}` : 'price-tax-label';

  return (
    <>
      <button
        type="button"
        className={btnClass}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
      >
        {text}
      </button>
      <TaxInfoModal
        open={open}
        onClose={() => setOpen(false)}
        config={config}
        prices={prices}
      />
    </>
  );
}
